//@import dependencies
import { chatbotChange } from 'app_events/app/actions'
import React, { CSSProperties, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { FaUsersCog, FaWhatsapp } from 'react-icons/fa'
//@end

//@import components
import { AiOutlineClose } from 'react-icons/ai'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './supportButtonCommon.scss'
import moment from 'moment'
import { TimeZone, TIME_ZONES_WITH_OFFSET } from 'app_services/user/zones'
import IconComponent from 'app_components/commons/icons';

// @ADD Component types
interface ISupportButtonCommonLayoutProps {
  open: boolean
  inRealTimeSupportLink?: string
  helpDeskLink?: string,
  whatsappLink?: string
  className?: string
  styles?: CSSProperties
  id?: string;
}


const avatarImage = require('app_assets/images/components/daniela-icon.png')

const SupportButtonCommonLayout: React.FC<ISupportButtonCommonLayoutProps> = (props) => {

  const dispatch = useDispatch()
  const {open: checkboxStatus} = props

  const handleCheckbox = () => {
    dispatch(chatbotChange({
      open: !checkboxStatus,
      page: null,
      metadata: null
    }))
  }

  const inRealTimeSupportLink = useMemo(() => {
    const currentDate = moment().utc().zone(TIME_ZONES_WITH_OFFSET[TimeZone.GMT_5])
    const day = currentDate.get('day')
    const hour = currentDate.get('hour')
    // Lunes a viernes de 9am a 5pm (COL) responde ICONTEC
    if (hour >= 9 && hour <= 17 && day >= 1 && day <= 5) {
      return props.whatsappLink
    } else {
      return props.inRealTimeSupportLink
    }
  }, [props.inRealTimeSupportLink, props.whatsappLink])

  return(
    <div className={`support-button-component ${checkboxStatus ? 'open' : ''}`}>
      <div className="support__overlay"></div>
      <section className="floating-button">
        <label htmlFor='control'>
          <div className="hide-button" style={{display: checkboxStatus ? 'flex' : 'none'}}>
            <div id="support-close-button" className="close_button__container" onClick={handleCheckbox}>
              <AiOutlineClose/>
            </div>
            <div
              id="support-main-section"
              className='d-flex flex-column align-items-end gap-3'
              style={{ paddingBottom: '60px' }}
            >
              {props?.helpDeskLink && (
                <>
                  <div>
                    <a target='_blank' rel="noreferrer" className="btn btn-link" href={inRealTimeSupportLink}  >
                      <span>¿No puedes ingresar al curso?</span>
                      <div className='circle__container green'>
                        <FaWhatsapp className="" color='white'></FaWhatsapp>
                      </div>
                    </a>
                  </div>
                  <div>
                    <a target='_blank' rel="noreferrer" className="btn btn-link" href={props.helpDeskLink}  >
                      <span>Mesa de ayuda estudiante y docente</span>
                      <div className='circle__container blue'>
                        <FaUsersCog className="" color='white'></FaUsersCog>
                      </div>
                    </a>
                  </div>
                </>
              )}
              <div>
                <a target='_blank' rel="noreferrer" className="btn btn-link" href="/tutorials"  >
                  <span>Tutoriales</span>
                  <div className='circle__container' style={{ backgroundColor: '#006398' }}>
                    <IconComponent svg="SupportTutorials" width={30} />
                  </div>
                </a>
              </div>
              {props?.whatsappLink && (
                <div>
                  <a target='_blank' rel="noreferrer" className="btn btn-link" href={props.whatsappLink}  >
                    <span>Compra servicios y PQRS</span>
                    <div className='circle__container green'>
                      <FaWhatsapp className="" color='white'></FaWhatsapp>
                    </div>
                  </a>
                </div>
              )}
            </div>
          </div>
        </label>
      </section>
      <div id='support-main-button' className='support-button--button-container' onClick={handleCheckbox}>
        <div className="support-button--button">
          <img alt="avatar" src={avatarImage} />
        </div>
        <div className='label'>Daniela</div>
      </div>
    </div>
  )
}

export default SupportButtonCommonLayout
